import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import master from './modules/master';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loading: true,
  },
  mutations: {
    SET_LOADING(state, value) {
      state.loading = value;
    },
  },
  actions: {},
  modules: {
    auth,
    master,
  },
});
